// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leftform-customer-type[data-v-49c4392c]{position:relative}.leftform-customer-type .customer-type[data-v-49c4392c]{position:absolute;top:-6px;font-weight:bolder;font-size:16px;white-space:nowrap;height:36px}", ""]);
// Exports
module.exports = exports;
